const LABEL_COLORS: Record<string, string> = {
  'A2020': '#006833',
  'A2015': '#00a651',
  'A2010': '#00a651',
  'A': '#00a651',
  'B': '#4caf50',
  'C': '#8bc34a',
  'D': '#ffeb3b',
  'E': '#ff9800',
  'F': '#ff5722',
  'G': '#f44336',
}

export function EnergyBadge({ label }: { label: string }) {
  const upper = label.toUpperCase()
  const color = LABEL_COLORS[upper] || '#9ca3af'
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      minWidth: 28, height: 28, borderRadius: 4, background: color,
      color: 'white', fontWeight: 700, fontSize: 13, padding: '0 6px',
    }}>
      {label}
    </span>
  )
}
